// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aLh6","input":"styles_input__trdPb"};